import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Swal from 'sweetalert2';
import { closeModal } from '../../../action/modalbehaviour.js';
import QuillEditor from '../../../utils/reactQuillEditor.jsx';
import Multiselect from 'multiselect-react-dropdown';


const AddAnnouncement = ({list}) => {
    const [editorValue, setEditorValue] = useState('');
    const [sendType, setSendType] = useState('0');
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [getEmployees, setEmployees] = useState([]);
    
    const schema = Yup.object().shape({
        subject: Yup.string().required(),
        body: Yup.string().required(),
    });
    
    const { register, handleSubmit, setValue, formState: { errors }, reset } = useForm({
        mode: 'all',
        resolver: yupResolver(schema),
        defaultValues: {
            subject: '',
            body: '',
        }
    });

    useEffect(() => {
        register('body');
    }, [register]);

    const onSubmit = async (data) => {
        // Add selected employees only if "send to all" is No
        if (data.is_send_to_all === '1') {
            data.employees = selectedEmployees.map((emp) => emp.id);
        }

        axiosInstance.post(`${process.env.REACT_APP_API_URL}/announcements`, data)
            .then(response => {
                Swal.fire({icon:"success", text:response.data.message});
                reset();
                setEditorValue('');
                setSendType('0');
                setSelectedEmployees([]);
                closeModal("add_announcement");
                list();
            })
            .catch(error => {
                Swal.fire({text:error, icon:"error"});
            });
    }

    const fetchEmployees = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/users?users=all`)
            .then(response => {
                setEmployees(response.data.data);
            })
            .catch(error => {
                console.error('Error fetching employees', error);
                setEmployees([]);
            });
    }

    useEffect(() => {
        fetchEmployees();

        const modalElement = document.getElementById('add_announcement');

        const handleClose = () => {
            reset();
            setEditorValue('');
            setSendType('0');
            setSelectedEmployees([]);
        };

        if (modalElement) {
            modalElement.addEventListener('hidden.bs.modal', handleClose);
        }
        return () => {
            if (modalElement) {
                modalElement.removeEventListener('hidden.bs.modal', handleClose);
            }
        };
    }, [reset]);

    const handleEditorChange = (content) => {
        setEditorValue(content);
        setValue('body', content, { shouldValidate: true });
    };

    const handleTypeChange = (event) => {
        const val = event.target.value;
        setSendType(val);
        setValue('is_send_to_all', val);
    };


    return (
        <div id="add_announcement" className="modal custom-modal fade modal-lg" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Add Announcement</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Subject/Title <span className="text-danger">*</span></label>
                                        <input className="form-control" type="text" {...register('subject')}/>
                                        <div className="text-sm text-danger">
                                            {errors.subject && <p>{errors.subject.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Body/Message <span className="text-danger">*</span></label>
                                        <QuillEditor value={editorValue} onChange={handleEditorChange} />
                                        <div className="text-sm text-danger">
                                            {errors.body && <p>{errors.body.message}</p>}
                                        </div>
                                    </div>
                                </div>                                    
                            </div>
                            <div className="col-md-12">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">Send to All <span className="text-danger">*</span></label>
                                    <div className="radio">
                                        <label className="col-form-label" style={{marginRight:'15px'}}>
                                            <input type="radio" value="0" {...register('is_send_to_all')} onChange={handleTypeChange} defaultChecked={sendType === '0' ? true : false}/> Yes
                                        </label>
                                        <label className="col-form-label" style={{marginRight:'15px'}}>
                                            <input type="radio" value="1" {...register('is_send_to_all')} onChange={handleTypeChange} defaultChecked={sendType === '1' ? true : false}/> No
                                        </label>
                                    </div>
                                </div>
                            </div>
                            {sendType === '1' && (
                                <div className="col-md-12 mb-3">
                                    <label className="col-form-label">Select Employees</label>
                                    <Multiselect
                                        options={getEmployees}
                                        selectedValues={selectedEmployees}
                                        onSelect={setSelectedEmployees}
                                        onRemove={setSelectedEmployees}
                                        displayValue="name"
                                        className="w-100"
                                        style={{ multiselectContainer: { minHeight: '45px' } }}
                                    />
                                </div>
                            )}
                            <div className="submit-section">
                                <button type="submit" className="btn btn-primary submit-btn">SEND</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddAnnouncement